import AddIcon from '@mui/icons-material/Add';
import { Box, Chip, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type React from 'react';

interface AddSectionTriggerProps {
  onAdd: () => void;
}

const AddSectionTrigger: React.FC<AddSectionTriggerProps> = ({ onAdd }) => {
  const theme = useTheme();

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        onAdd();
      }}
      className="add-section-trigger"
      sx={{
        height: '8px',
        width: '100%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0,
        position: 'absolute',
        bottom: '-4px', // Center on the border
        left: 0,
        right: 0,
        zIndex: 10,
        transition: 'all 0.2s ease',
        '&:hover': {
          height: '24px',
          bottom: '-12px',
          opacity: 1,
          zIndex: 100,
        },
      }}
      title="Add section here"
    >
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', px: 4 }}>
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            bgcolor: 'success.main',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 2,
            mr: 1,
            transition: 'transform 0.2s',
            '.add-section-trigger:hover &': {
              transform: 'scale(1.1)',
            },
          }}
        >
          <AddIcon sx={{ fontSize: 16 }} />
        </Box>
        <Divider sx={{ flexGrow: 1, borderColor: theme.palette.bidlogiq.orange }}>
          <Chip
            label="Add Section"
            size="small"
            sx={{
              cursor: 'pointer',
              fontWeight: 'bold',
              height: '20px',
              fontSize: '0.7rem',
              bgcolor: theme.palette.bidlogiq.brick,
              color: 'white',
              '&:hover': {
                bgcolor: theme.palette.bidlogiq.rust,
              },
            }}
          />
        </Divider>
      </Box>
    </Box>
  );
};

export default AddSectionTrigger;
